/* =============================================================================
   ics-UI i18n - the BN (Bengali) catalog of component-emitted strings, keyed
   exactly as the en base catalog. The localisation map imports it on demand
   when the locale is activated, so it costs nothing on an install that never
   selects Bengali.
   SPARSE BY DESIGN: it holds only the keys that have a confirmed Bengali
   string; every other key falls back to the en base catalog, so a missing key
   shows English rather than a blank. Unicode Bengali only - Bengali text a
   screen stores in an 8-bit font encoding is DATA, never a catalog entry.
   ============================================================================= */
export default {
  /* sparse by design: a key lands here once its Bengali string is confirmed */
};
